import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  listLlmOverridesConfig,
  updateLlmOverridesConfig,
} from '../lib/llmoverrides.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  listLlmOverridesSlice,
  listLlmOverridesLoadingSlice,
} from '../slices/prompts.slice';

export const listLlmOverridesAction = (selectedOrg) => {
  return async (dispatch) => {
    dispatch(listLlmOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrg}`,
        'Headless-Mode': true,
      };
      const { url } = listLlmOverridesConfig();
      const result = await Axios.get(url, { headers });
      if (result?.status === 200) {
        dispatch(listLlmOverridesSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load LLM overrides');
    } finally {
      dispatch(listLlmOverridesLoadingSlice(false));
    }
  };
};

export const updateLlmOverridesAction = (
  selectedOrg,
  payload,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(listLlmOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrg}`,
        'Headless-Mode': true,
      };
      const { url } = updateLlmOverridesConfig();
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(listLlmOverridesSlice(result?.data));
        if (successCallback) {
          showToastSuccess('LLM overrides updated successfully');
          successCallback();
        }
        // Refresh the data after update
        dispatch(listLlmOverridesAction(selectedOrg));
      }
    } catch (e) {
      showToastError('Failed to update LLM overrides');
    } finally {
      dispatch(listLlmOverridesLoadingSlice(false));
    }
  };
};
